import { PageHero } from "./AboutPage";
import { Seo } from "../components/Seo";
import { useSite } from "../context/SiteContext";
import { LEGAL } from "../lib/translations";

export default function LegalPage({ type }) {
  const { lang } = useSite();
  const c = LEGAL[lang][type];
  return (
    <main data-testid={`${type}-page`}>
      <Seo title={`${c.title} | Noyola Construction LLC`} path={`/${type}`} />
      <PageHero overline={lang === "es" ? "Legal" : "Legal"} title={c.title} />
      <section className="py-20 bg-[#F8FAFC]">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 space-y-10">
          {c.sections.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-heading font-bold text-[#0B1B3D] text-xl mb-3">{h}</h2>
              <p className="text-slate-600 leading-relaxed">{p}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
